<template>
    <div class="rating-board-container">
        <div class="ratings">
            <rating title="制作精美程度" class="design-rating"
                scoreColor="#494949"
                :rating="rating.designrating"
                :labels="designLabels"
                :formula="formula"
            />
            <rating title="最低通关难度" class="difficulty-rating"
                :scoreColor="calDifficultyColor"
                :rating="rating.difficultyrating"
                :labels="difficultyLabels"
                :formula="formula"
            />
        </div>
        <blockquote>
            “制作精美程度”代表你觉得这塔制作的多么优秀。<br />
            “最低通关难度”仅作为面向没玩过该塔的玩家的通关难度参照。<br/>
            最低通关难度分越高，说明这塔（最低难度下）越难以通关，越不适合新人进行游戏。<br/>
            平均分计算已去掉(10%+1)最高和(10%+1)最低<br/>
            少于10人评分时不显示分数
        </blockquote>
        <div v-if="myrate">
            <div>
                制作精美程度:
                <a-rate
                    :value="designRate"
                    @change="(v) => rate('design', v)"
                    :tooltips="designLabels"
                ></a-rate>
                <span class="ant-rate-text">{{ designRate ? designLabels[designRate - 1] : '' }}</span>
            </div>
            <div>
                最低通关难度:
                <a-rate class="difficulty-rate"
                    :value="Number(myrate.difficultyRate)"
                    @change="(v) => rate('difficulty', v)"
                    :tooltips="difficultyLabels"
                    character="■"
                ></a-rate>
                <span class="ant-rate-text">{{ designRate ? difficultyLabels[difficultyRate - 1] : '' }}</span>
            </div>
        </div>
        <div v-else>
            通关此塔才能评分
        </div>
    </div>
</template>

<script>
import Rating from '../components/Rating.vue';
import { default as ARate } from 'ant-design-vue/es/rate';
import axios from 'axios';
import { createFormData } from '../../../utils/utils';

export default {
    props: {
        rating: Object,
        myrate: Object
    },
    data: () => ({
        designLabels: ['极差', '较差', '一般', '较好', '极好'],
        difficultyLabels: ['极易', '较易', '一般', '较难', '极难'],
        onRating: false,
    }),
    inject: [ 'app' ],
    computed: {
        designRate() {
            return Number(this.myrate.designRate);
        },
        difficultyRate() {
            return Number(this.myrate.difficultyRate);
        },
    },
    methods: {
        calDifficultyColor(score) {
            return `rgb(${255*(score-1)/5 },${255*(5-score)/4}, 33)`;
        },
        /**
         * @param {number[]} stat
         */
        formula(stat) {
            const count = stat.reduce((sum, e) => sum + e, 0);
            if (count < 10) {
                return "---";
            }
            const removecnt = (count / 10 + 1);
            const _stat = stat.concat();
            for (let i = 0, removemin = removecnt; i < 4; i++) {
                while (removemin > 0) {
                    if (_stat[i] > 0) {
                        _stat[i]--;
                        removemin--;
                    } else {
                        break;
                    }
                }
            }
            for (let i = 4, removemax = removecnt; i > -1; i--) {
                while (removemax > 0) {
                    if (_stat[i] > 0) {
                        _stat[i]--;
                        removemax--;
                    } else {
                        break;
                    }
                }
            }
            const _count = count - 2 * removecnt;
            const sum = _stat.reduce((sum, e, i) => sum + e * (i+1), 0);
            return (sum / _count).toFixed(2);
        },
        async rate(type, value) {
            try {
                const name = this.app.tower.name;
                this.onRating = true;
                const { data } = await axios
                    .post("/backend/tower/rateOld.php", createFormData({
                        name, type, value
                    }));
                if (data.code == 0) {
                    this.$message.success(`投票成功`);
                    this.app.rating = data.rating;
                    this.app.myrate = data.myrate;
                }
            } catch (e) {
                this.$message.error(`投票失败: ${ e }`);
            } finally {
                this.onRating = false;
            }
        }
    },
    components: {
        Rating, ARate,
    },
}
</script>

<style lang="less" scoped>
.rating-board-container {
    text-align: left;
    margin-left: 10px;
}
.ratings {
    display: flex;
    margin-bottom: 20px;
}
.design-rating {
    border-right: 1px solid #dddddd;
}
.difficulty-rating {
    margin-left: 50px;
}
.difficulty-rate {
    font-size: 32px;
}
</style>

<style lang="less">
blockquote {
    display: block;
    border-left: 8px solid #d0e5f2;
    padding: 5px 10px;
    margin: 10px 0;
    line-height: 1.4;
    font-size: 100%;
    background-color: #f1f1f1;
    p {
        margin: 10px 0;
        line-height: 1.5;
    }
}
</style>